import { getRecipeCatalogId, getRecipeName } from "./recipeId";

/**
 * Map DietDB recipe (fetch-recipes) to meal-editor detail shape (nutrients, measures, …).
 */
export function recipeCatalogToMealDetail(recipe) {
  const recipeId = getRecipeCatalogId(recipe);
  if (!recipeId) return null;

  const name = getRecipeName(recipe) || recipe.name || "";
  const baseGrams = Number(recipe.serving_size_grams) > 0 ? Number(recipe.serving_size_grams) : 100;

  const DISPLAY_TAGS = new Set([
    "ENERC_KCAL",
    "PROCNT",
    "CHOCDF",
    "FAT",
    "FIBTG",
    "SUGAR",
  ]);
  const tagToKey = {
    ENERC_KCAL: "calories",
    PROCNT: "proteins",
    CHOCDF: "carbs",
    FAT: "fats",
    FIBTG: "fiber",
    SUGAR: "sugars",
  };
  const nutrients = {
    calories: 0,
    proteins: 0,
    carbs: 0,
    fats: 0,
    fiber: 0,
    sugars: 0,
  };
  (recipe.nutrient_composition || []).forEach((n) => {
    const tag = n.nutrient_tag_name;
    if (!DISPLAY_TAGS.has(tag)) return;
    const key = tagToKey[tag];
    if (key) nutrients[key] = Number(n.measure ?? 0);
  });

  const measures = [];
  const seenUnits = new Set();
  (recipe.serving_sizes || []).forEach((ss) => {
    const label = (ss.serving_size_description || "").trim();
    if (!label) return;
    const key = label.toLowerCase();
    if (seenUnits.has(key)) return;
    seenUnits.add(key);
    const conv = ss.conversion_grams;
    measures.push({
      unit_option_name: label,
      basic_unit_measure:
        conv != null && conv !== "" && Number.isFinite(Number(conv)) ? Number(conv) : 1,
      serving_size_unit: "g",
    });
  });
  if (!seenUnits.has("g")) {
    measures.unshift({
      unit_option_name: "g",
      basic_unit_measure: 1,
      serving_size_unit: "g",
    });
  }

  return {
    food_id: recipeId,
    recipe_id: recipeId,
    recipe_name: name,
    food_name: name,
    common_names: recipe.other_names || recipe.common_names || "",
    calories_calculated_for: baseGrams,
    nutrients,
    measures,
  };
}
